export default {
  letsPlayBrand: "LET’s PLAY",
  "courtSize": {"single": "Singola", "double": "Doppio"},
  "unfinishedColumn": "Parziale",
  "rejectedSave": "Il tuo club non poteva accettare questi cambiamenti. Le tue azioni locali sono mantenute. Verifica il punteggio più recente o scarica le tue azioni prima di scartarle.",
  "unverifiedSave": "Non possiamo verificare il salvataggio. Le tue azioni locali sono mantenute. Verifica il punteggio più recente o scarica le tue azioni prima di scartarle.",

  "finishQuestion": "Fine sessione?",
  "saveFinish": "Salva e termina",
  "unfinishedOutcome": "Sessione incompiuta",
  "tiedOutcome": "Livello dei punteggi",
  "finishedOutcome": "Sessione terminata",
  "savingResult": "Salvato su questo dispositivo · Risparmio al vostro club...",
  "offlineResult": "Salvato su questo dispositivo · Verrà sincronizzato quando collegato",
  "syncedResult": "Salvato al tuo club",
  "momentWaiting": "Il vostro momento si aprirà una volta salvando completa...",
  "saveFailed": "Non poteva sincronizzare. Il tuo punteggio è mantenuto su questo dispositivo.",

  "deleteChanged": "Questa sessione è cambiata prima che possa essere cancellato. Riprendilo per rivedere gli ultimi punteggi, quindi provare a cancellare di nuovo.",
  "moreActions": "Altro",
  "deleteSession": "Eliminare la sessione",
  "deleteNote": "Rimozione di questa sessione da Continua a giocare? I punteggi e la cronologia degli audit sono mantenuti. Le prenotazioni della Corte sono invariate.",
  "deletePending": "Questa sessione ha punteggi non sincronizzati o una bozza locale. Riprendilo per sincronizzare o rivedere e scartare il lavoro prima di eliminare.",
  "deleting": "Deleting...",
  "live": "In diretta",
  "completedSet": "Set completo",
  "completedGame": "Gioco completo",
  "sports": "Sport",
  "format": "Formato",
  "pointAction": "N.",
  "serviceSetup": "Configurazione del servizio",
  "finalScores": "Punteggio finale",
  "scoringMode": "Modalità di punteggio",
  "enterScores": "Inserisci i tuoi punteggi",
  "reviewSave": "Recensione & salva",
  "applyContinue": "Applicare i punteggi e continuare in diretta",
  "discardContinue": "Scarta le modifiche e continua in diretta",
  "changeService": "Cambia server / servizio",
  "choose": "Scegli...",
  "rallyWon": "Rally ha vinto",
  "discardChanges": "Disattivare le modifiche",
  "error_draft_unreadable": "Il progetto di punteggio finale memorizzato non potrebbe essere letto. Mantenere i dati del dispositivo e il supporto di contatto prima di sostituirlo.",
  "error_draft_action_required": "Rivedere i tuoi punteggi finali cambia, scartarli, o continuare a modificare prima di segnare un altro modo.",
  "error_draft_consent_required": "Rivedere il punteggio di sostituzione e confermare di finire.",
  "error_draft_revision_changed": "Confronta le tue voci con l'ultimo punteggio salvato e conferma il confronto qui sotto.",
  "error_point_mode_changed": "Confermare i nuovi controlli dei punti qui sotto prima di rivedere questo punteggio.",
  "error_point_combination_invalid": "Il vantaggio deve essere abbinato a 40. Per il deuce, scegliere 40 per entrambi i giocatori.",
  "keepDraftAndLeave": "Mantenere i cambiamenti e lasciare",
  "discardAndLeave": "Eliminare i cambiamenti e lasciare",
  "keepEditing": "Continua a modificare",
  "draftLeaveNote": "I tuoi punteggi non sono stati applicati. Tienili per tornare più tardi, scartarli, o continuare a modificare.",
  "unappliedChanges": "Cambiamenti di punteggio non applicati",
  "reviewAndFinish": "Punteggio e sessione di finitura",
  "cardDraftPreserved": "Variazioni dei punteggi finali non applicati",
  "draftPending": "Queste modifiche riviste sono in coda, non possono essere applicate due volte.",
  "draftStorageError": "Le tue modifiche sono ancora qui, ma non potrebbero essere memorizzate su questo dispositivo. Tenere questo schermo aperto e riprovare.",
  "directHistoryDetails": "Questo sostituisce i progressi di punteggio dipendente, compreso il gioco successivo. Tutte le azioni precedenti rimangono in Storia.",
  "replacementDetails": "Quali cambiamenti?",
  "reconcileDraft": "Ho confrontato le mie voci con l'ultimo punteggio salvato",
  "draftRevisionChanged": "Il punteggio salvato è cambiato mentre stavi modificando. Confrontalo con le tue voci di seguito prima di sostituirlo.",
  "useOrdinaryPoints": "Utilizzare i punti di gioco · punti corrente chiari",
  "useTieBreakPoints": "Utilizzare punti tie-break · punti corrente chiari",
  "pointModeChanged": "Il set finale ha cambiato la modalità di punteggio. Scegliere il controllo del punto esplicitamente; questo chiarirà i punti attuali.",
  "advantage": "Vantaggio",
  "loveZero": "L'amore / 0",
  "serviceUnknown": "Servizio non registrato",
  "interpreting": "Interpretare...",
  "reopenCorrection": "Questa correzione riaprisce la sessione. Verifica il punteggio e termina nuovamente la sessione per salvarlo.",
  "tieBreakFirstServer": "Chi ha servito per primo in questa tie-break?",
  "preparingMatch": "Preparare il tuo match",
  "preparingDetail": "Preparare campi e giocatori",
  "restoringMatch": "Ripristinare la partita",
  "restoringDetail": "Preparare la scheda di punteggio",
  "setupProgress": "Configurazione di corrispondenza",
  "member": "Socio",
  "session_saved": "Sessione salvata",
  "sessionSaved": "Sessione salvata",
  "sessionPending": "Sessione in attesa di sincronizzazione",
  "playEnded": "Il gioco è finito. Nessun vincitore assoluto ha dichiarato.",
  "finishSession": "Recensione & salva",
  "set": "Set Set",
  "game": "Gioco",
  "points": "Punti",
  "unfinishedSegment": "In corso · incompiuto",
  "segmentCompleted": "Completato",
  "addSet": "Aggiungi un altro set",
  "addGame": "Aggiungi un altro gioco",
  "currentPointsOptional": "Punti attuali (opzionale)",
  "directHistoryAck": "Sostituire il punteggio registrato",
  "directEntryReason": "Entrata nella scheda di punteggio",
  "reviewScore": "Recensione & salva",
  "receivingFirst": "Chi riceve per primo nell'altra squadra?",
  "rightCourt": "Giocatore a destra · squadra",
  "startLive": "Continua a giocare in diretta",
  "operation_direct_score": "Punteggio inserito",
  "operation_configure_service": "Servizio confermato",
  "operation_finish_session": "Sessione terminata",
  "error_unfinished_segment_must_be_last": "Solo il segmento finale può essere incompiuto. Completalo prima di aggiungere un altro.",
  "error_mark_segment_completed": "Questo punteggio completa il segmento. Segnalo completato, o correggere il punteggio.",
  "correctLastRally": "Correggere l'ultima gara",
  "operation_replace_last_rally": "Ultimo raduno corretto",
  "conflictStatus": "Bisogno recensione",
  "storageStatus": "Bisogno recensione",
  "pendingOnline": "Risparmio",
  "historyTitle": "La tua Let’s Play",
  "historyIntro": "I round, i giochi e i momenti che hai condiviso.",
  "all": "Tutti",
  "filterHistory": "Filtra la storia",
  "historyLoad": "Carica la tua storia",
  "historyEmptyTitle": "La tua storia inizia qui.",
  "historyEmpty": "Qui appariranno attività complete.",
  "more": "Caricamento di più",
  "manageMoment": "Gestire il momento",
  "photoUnavailable": "Foto non disponibile",
  "moment_loadError": "Non siamo riusciti ad aprire questo momento di attività.",
  "moment_imageError": "Scegliere un'immagine JPEG, PNG o WebP fino a 15 MB.",
  "moment_discard": "Togliete questa foto?",
  "moment_offline": "Sei offline. La tua attività è sicura — aggiungere questo momento più tardi da Storia.",
  "moment_conflict": "Questo momento è cambiato su un altro dispositivo. Ricarica prima di provare di nuovo.",
  "moment_saveError": "La tua foto non è stata salvata. Tienila qui e riprova.",
  "moment_captionError": "La capzione non poteva essere salvata.",
  "moment_removeConfirm": "Rimozione di questo momento? L'attività completa non sarà cambiata.",
  "moment_removeError": "Il momento non poteva essere rimosso. Ricaricare e riprovare.",
  "moment_opening": "Apri il tuo momento",
  "moment_access": "Controllo dell'accesso all'attività",
  "moment_unavailable": "Momento non disponibile",
  "moment_label": "MOMENTO DI ATTIVITÀ",
  "moment_from": "Un momento da questa attività",
  "moment_none": "Nessun momento è stato catturato",
  "moment_alt": "Momento di attività",
  "moment_your": "TUO MOMENTO",
  "moment_activityComplete": "COMPLETA DI ATTIVITÀ",
  "moment_remember": "Ricordati di questo",
  "moment_capture": "Catturate il momento?",
  "moment_intro": "Grandi giochi vale la pena ricordare.",
  "moment_editCaption": "Modifica della captazione",
  "moment_saveCaption": "Salva la captazione",
  "moment_remove": "Rimozione del momento",
  "moment_take": "Fai la foto.",
  "moment_replace": "Sostituisci la foto",
  "moment_choose": "Scegli la foto",
  "moment_later": "Non ora.",
  "moment_keep": "Tieni questo?",
  "moment_preview": "Anteprima del momento selezionato",
  "moment_caption": "Aggiungere una didascalia (opzionale)",
  "moment_captionExample": "Escursione estiva con Chris",
  "moment_preparing": "Preparare e salvare...",
  "moment_save": "Salvare il momento",
  "moment_another": "Scegli un altro",
  "error_invalid_segment_score": "Inserire un set / punteggio di gioco valido completato, o contrassegnare l'ultima riga incompiuta. Controlla ogni riga evidenziata.",
  "error_invalid_point_score": "Utilizzare 0, 15, 30, 40 o vantaggio. Un gioco finito ha bisogno di un riassunto di gioco.",
  "error_invalid_game_score": "Inserire un punteggio impostato incompiuto fino a 6–6, o registrare un insieme completato.",
  "error_invalid_correction": "Inserisci entrambi i punteggi e scegli il server e la casella di servizio.",
  "error_service_information_required": "Scegliere esplicitamente il server successivo e la casella di servizio.",
  "error_invalid_service_box": "La casella di servizio non corrisponde a questo punteggio e al server. Controlla la loro posizione di campo.",
  "error_invalid_service_order": "Controllare l'ordine di servizio. Le squadre di tennis e Padel devono alternarsi.",
  "error_server_number_required": "Scegliere il server 1 o 2 per il doppio, o il server 1 per i singoli.",
  "error_court_positions_required": "Confermare il giocatore di destra di ogni squadra prima di applicare.",
  "error_invalid_court_positions": "Il server selezionato non è nella casella di servizio selezionata. Controlla le posizioni del campo.",
  "error_terminal_score_requires_segment": "Questo punteggio termina un gioco o un set. Utilizzare un riepilogo segmento completato.",
  "error_summary_would_rewrite_games": "Il punteggio finale non può cancellare i giochi già registrati. Correggere i giochi attuali prima o rivedere i segmenti storici.",
  "error_dependent_history_requires_resolution": "Confermare che tutti i segmenti successivi e i progressi attuali saranno scartati.",
  "error_queue_capacity_reached": "La coda del dispositivo è piena. Ricollegare per salvare prima di registrare più azioni.",
  "error_court_not_available_for_sport": "Questa corte non è più disponibile per questo sport. Scegli un'altra corte.",
  "error_format_not_supported_by_court": "Scegli un formato supportato da questo campo o seleziona un altro campo.",
  "error_duplicate_participant": "Ogni giocatore deve comparire una volta. Controlla squadre e nomi degli ospiti.",
  "error_reason_required": "Inserire una ragione in modo che la correzione sia chiara nella cronologia delle partite.",
  "tieBreak": "Tie-break",
  "currentGames": "Giochi attuali (reimposta punti correnti)",
  "operation_correct_games": "Riepilogo dei giochi attuali",
  "court": "Campo",
  "match": "Abbinamento",
  "players": "Giocatori",
  "review": "Recensione",
  "where": "Dove stiamo giocando?",
  "how": "Come giochiamo?",
  "who": "Chi sta giocando?",
  "ready": "Pronto a giocare?",
  "back": "Indietro",
  "next": "Continua",
  "retry": "Riprova",
  "loading": "Caricamento della partita...",
  "error": "Non abbiamo potuto completare questa richiesta. Controllare la vostra connessione e riprovare.",
  "noCourts": "Non sono configurati campi idonei. Contattare il club per configurare un campo per questo sport.",
  "noReservation": "Avviare una scheda di punteggio non riserva un campo o addebitare il tuo account.",
  "indoor": "Interno",
  "outdoor": "All'aperto",
  "singles": "Singola",
  "doubles": "Doppio",
  "adjust": "Regolare il punteggio",
  "start": "Iniziare la partita",
  "starting": "Cominciare...",
  "edit": "Modifica",
  "resumeMatches": "Continua a giocare",
  "recent": "Giocatori recenti",
  "search": "Trova un socio del club",
  "noResults": "Nessun socio corrispondente",
  "guest": "Nome ospite",
  "addGuest": "Aggiungere gli ospiti",
  "remove": "Rimuovi",
  "move": "Spostarsi in altra squadra",
  "team": "Squadra",
  "youScorer": "Siete il segnapunti. Altri partecipanti possono vedere questa partita.",
  "server": "Server",
  "firstServer": "Chi serve per primo?",
  "order": "Ordine di servizio",
  "initialBox": "Scatola di servizio iniziale",
  "left": "Sinistra",
  "right": "Giusto.",
  "requiredPlayers": "Aggiungere i giocatori richiesti e assegnare squadre uguali.",
  "saved": "Salvataggio",
  "saving": "Risparmio",
  "pending": "Linea offline",
  "conflict": "Questa partita è cambiata su un altro dispositivo. Le tue azioni in sospeso sono conservate.",
  "export": "Scarica le azioni in sospeso",
  "useServer": "Mantenere il punteggio del server e scartare le azioni in sospeso",
  "discardConfirm": "Ho esaminato il punteggio del server e voglio scartare queste azioni in sospeso.",
  "storageError": "L'archiviazione del dispositivo non è disponibile. Tenere aperta questa schermata e riconnettersi per salvare. Scarica le azioni in sospeso prima di partire.",
  "card": "Punteggio finale",
  "rally": "Rally ha vinto",
  "point": "Punto vinto",
  "undo": "Condividi su Facebook",
  "voice": "Voce",
  "pause": "Pausa",
  "resume": "Ripresa",
  "paused": "Partita in pausa",
  "landscape": "paesaggio paesaggio",
  "portrait": "Ritratto",
  "rotate": "Ruotare il dispositivo per una vista più ampia sul lato della corte. La serratura di rotazione del dispositivo potrebbe essere necessario disattivare.",
  "swap": "Lati di visualizzazione Swap",
  "sets": "Set",
  "games": "Giochi",
  "serving": "Servo",
  "boxRequired": "Scegli la casella di servizio prima del prossimo rally.",
  "correct": "Corretto / ingresso rapido",
  "preview": "Punteggio della recensione",
  "apply": "Confermare il cambiamento",
  "cancel": "Annulla",
  "before": "Prima di prima",
  "after": "Dopo",
  "reason": "Motivo di correzione",
  "current": "Punti attuali",
  "awardGame": "Gioco attuale premio (sommario)",
  "summary": "Registrazione completata set/game",
  "historical": "Sostituire un segmento precedente",
  "summaryNote": "La voce sommaria registra il punteggio senza inventare raduni. Le statistiche dei punti non sono disponibili per i segmenti di sintesi.",
  "discardFollowing": "Scartare tutti i segmenti successivi e i progressi attuali dopo questo segmento",
  "segment": "Segmento",
  "history": "Azioni registrate",
  "summaryOnly": "Sintesi",
  "rallyHistory": "Raduno",
  "confirmResult": "Confermare il risultato finale",
  "resultReady": "Un vincitore — pronto a confermare?",
  "completed": "Abbinamento completo",
  "retired": "Ritiro",
  "abandoned": "Abbandonati",
  "unfinished": "Incompiuto",
  "in_progress": "In corso",
  "awaiting_confirmation": "Risultato in attesa di conferma",
  "winner": "Vincitore",
  "endEarly": "Fine partita anticipata",
  "retire": "Respinta",
  "abandon": "Abbandono",
  "finishUnfinished": "Salva come incompiuto",
  "earlyNote": "Questo mantiene il punteggio senza dichiarare una vittoria completa.",
  "scorecard": "Visualizza la scheda di punteggio",
  "done": "Torna a Let’s Play",
  "moment": "Aggiungi un momento",
  "share": "Risultato della condivisione",
  "shareNote": "Condividi solo lo sport e il punteggio. I nomi dei giocatori, gli ospiti e i link dei media privati sono esclusi.",
  "listen": "Punteggio record",
  "stop": "Smettere di registrare",
  "transcript": "Trascrizione originale",
  "interpret": "Punteggio dell'interprete",
  "voiceReview": "Punteggio voce recensione",
  "voiceFailure": "La voce non è disponibile. Puoi continuare a segnare manualmente o inserire la trascrizione qui sotto.",
  "clarify": "Maggiori informazioni necessarie",
  "repair": "Trascrizione consigliata riparazione",
  "ackRepair": "Riconosco questa riparazione trascrizione",
  "staleVoice": "La partita o il display sono cambiati. Interpretare di nuovo prima di applicare.",
  "deuce": "Parità",
  "gamePoint": "Punto di gioco",
  "matchPoint": "Punto di partenza",
  "readOnly": "È possibile visualizzare questa partita. Solo il suo creatore può segnare.",
  "source": "Fonte delle regole",
  "unknown": "Scegli esplicitamente",
  "serverNumber": "Numero del server",
  "positions": "Giocatore di piazza destra",
  "savedMatches": "Le tue partite",
  "noMatches": "I tuoi fiammiferi appariranno qui.",
  "tennis": "Tennis",
  "padel": "Padella",
  "pickleball": "Pallacanestro",
  "squash": "Squash.",
  "tennis_one_set": "Un set · vantaggio · tie-break a 6–6",
  "tennis_best_of_three": "Miglior 3 set · vantaggio · tie-break a 6–6",
  "padel_advantage": "Miglior 3 set · vantaggio (opzione FIP 1)",
  "pickleball_one_game": "Un gioco a 11 · lato-out · vincere da 2",
  "pickleball_best_of_three": "Migliore di 3 a 11 · lato-out · vittoria per 2",
  "squash_best_of_three": "Migliore di 3 a 11 · punto-a-rally · vittoria per 2",
  "squash_best_of_five": "Miglior da 5 a 11 · punto-a-rally · vittoria per 2",
  "operation_rally": "Rally ha vinto",
  "operation_undo": "Condividi su Facebook",
  "operation_correct_current": "Punteggio corrente corretto",
  "operation_award_game": "Riepilogo del gioco",
  "operation_summary_segment": "Riepilogo del segmento",
  "operation_replace_segment": "Correzione storica; in seguito i progressi scartati",
  "operation_pause": "In pausa",
  "operation_resume": "Risoluzioni",
  "operation_confirm_result": "Risultato confermato",
  "operation_service_box": "Scatola di servizio selezionata",
  "operation_retire": "Ritiro",
  "operation_abandon": "Abbandonati",
  "operation_unfinished": "Salvataggio incompiuto",
  "moreOptions": "Altre opzioni",
  "backToScores": "Torna ai punteggi",
  "pointsForUnfinished": "Solo registrare i punti correnti per un insieme incompiuto.",
  "error_completed_segment_has_points": "I punti attuali rimangono dal live scoring. Tenerli in un nuovo set incompiuto, o chiarirli esplicitamente prima di salvare i set completi.",
  "clearStalePoints": "Punti correnti chiari",
  "retainUnfinishedPoints": "Tenere i punti in un set non finito",
  "resultHeading": "Uno per la storia.",
  "sessionWinner": "Risultato della sessione",
  "playEndedEarly": "Il gioco è finito presto",
  "runnerUp": "Secondo classificato",
  "continue": "Continua",
  "backToResult": "Torna al risultato",
  "completionAttention": "Ha bisogno di attenzione. I tuoi punteggi in sospeso sono conservati.",
  "savedOnDevice": "Salvato su questo dispositivo · in attesa di sincronizzazione",
  "serverConfirmed": "Confermato dal server",
  "proposedScore": "Il punteggio finale",
  "finishNote": "Questo salva i punteggi e finisce giocare.",
  "replaceAndFinish": "Sostituisci i punteggi e finisci",
  "saveAndFinish": "Salva e termina",
  "replaceAndContinue": "Sostituire i punteggi e continuare",
  "levelOnSets": "Livello sui set",
  "levelOnGames": "Livello sui giochi",
  "reviewChanged": "I punteggi sono cambiati. Cancellare questa recensione, confrontare l'ultimo punteggio e rivedere di nuovo.",
  "preparingReview": "Preparare la recensione...",
  "reviewPreparationError": "Non siamo riusciti a preparare questa recensione vocale. Annullare e rivedere di nuovo; i tuoi punteggi sono conservati."
}
